import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const ChooseAdAccount = () => {
  const [adAccoountId, setAdAccountId] = useState('842117447457126');
  return (
    <div className='mt-4 mb-4' data-aos='fade-up' data-aos-delay='200'>
      <div className='row d-flex justify-content-center pt-lg-0 border-bottom'>
        <h3>Choose Ad Account</h3>
      </div>

      <div className='row d-flex justify-content-center pt-lg-0 mt-4'>
        <span>Account with media (image and video): </span>{' '}
        <Link to={`/accountDashboard/1950065302115201`} className='text-primary ml-2'>
          1950065302115201
        </Link>
      </div>
      <div className='row d-flex justify-content-center pt-lg-0 mt-4'>
        <h6>Enter Ad Account Id</h6>
      </div>

      <div className='row d-flex justify-content-center pt-lg-0'>
        <div className='col-md-6'>
          <input
            type='text'
            className='form-control'
            style={{ textAlign: 'center' }}
            defaultValue={adAccoountId}
            onChange={(e) => setAdAccountId(e.target.value)}
          />
        </div>
      </div>
      {adAccoountId ? (
        <div className='row d-flex justify-content-center pt-lg-0 mt-4' data-aos='fade-up' data-aos-delay='200'>
          <Link className='btn btn-outline-primary' to={`/accountDashboard/${adAccoountId}`}>
            Go To Ad Account
          </Link>
        </div>
      ) : null}
    </div>
  );
};

export default ChooseAdAccount;
